var Position;
(function (Position) {
    Position[Position["TOP"] = 1] = "TOP";
    Position[Position["BOTTOM"] = 2] = "BOTTOM";
    Position[Position["LEFT"] = 4] = "LEFT";
    Position[Position["RIGHT"] = 8] = "RIGHT";
    Position[Position["VERTICAL"] = 3] = "VERTICAL";
    Position[Position["HORIZONTAL"] = 12] = "HORIZONTAL";
})(Position || (Position = {}));
export default Position;
